module.exports = __webpack_public_path__ + "img/wulianwang (5).4f1eba05.png";